import React, { useContext, useMemo } from 'react';
import Select from 'react-select';
import ThemeContext from '../../../contexts/theme';
import { getReactSelectStyles } from '../../../utils/reactSelectThemeStyles';

const SelectSearch = ({
  options,
  nameInput,
  isDisabled,
  isLoading,
  value,
  setValue
}) => {

  const themeContext = useContext(ThemeContext);
  const theme = themeContext?.theme || 'light';
  // It carried no styles at all, so it kept react-select's white control and
  // near-black text in dark mode.
  const selectStyles = useMemo(() => getReactSelectStyles(theme), [theme]);

  const updateFormField = (item) => {
    setValue && setValue(nameInput, item?.value || null);
  };  

  return (
    <Select
      className="basic-single"
      classNamePrefix="select"
      styles={selectStyles}
      placeholder="Seleccione"
      isDisabled={isDisabled}
      isLoading={isLoading}
      isClearable={false}
      isSearchable={true}
      name={nameInput}
      options={options}
      value={value ? options.find((option) => option.value === value) : null}
      onChange={(selectedOption) => {
        updateFormField(selectedOption);
      }}
    />
  );
};

export default SelectSearch;
